import React from "react";
import "./SaasSections.css";

const nodes = [
  { top: "15%", left: "20%" },
  { top: "45%", left: "70%" },
  { top: "70%", left: "30%" },
  { top: "25%", left: "85%" },
  { top: "60%", left: "55%" },
];

export default function HeroAnimatedBackground() {
  return (
    <div className="hero-saas-bg" aria-hidden="true">
      <div className="hero-saas-bg__grid" />
      <div className="hero-saas-bg__gradient hero-saas-bg__gradient--1" />
      <div className="hero-saas-bg__gradient hero-saas-bg__gradient--2" />
      <div className="hero-saas-bg__nodes">
        {nodes.map((node, i) => (
          <span
            key={i}
            className="hero-saas-bg__node"
            style={{
              top: node.top,
              left: node.left,
              animationDelay: `${i * 0.6}s`,
            }}
          />
        ))}
      </div>
    </div>
  );
}
